export default [
  {
    meta: {
      icon: 'iconfont iconjichuxinxiguanli',
      title: '哈弗商城',
      uri: '/newRetail/hafoApplets',
    },
    subMenus: [
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '首页内容管理',
          uri: '/newRetail/hafoApplets/homeContentManager',
        },
        component: () => import('./hafoApplets/homeContentManager/index.vue'),
        path: '/hafoApplets/homeContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '车系内容管理',
          uri: '/newRetail/hafoApplets/carContentManager',
        },
        component: () => import('./hafoApplets/carContentManager/index.vue'),
        path: '/hafoApplets/carContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '报名活动管理',
          uri: '/newRetail/hafoApplets/registrationActivities',
        },
        component: () => import('./hafoApplets/registrationActivities/index.vue'),
        path: '/hafoApplets/registrationActivities',
      },
    ],
  },
  {
    meta: {
      icon: 'iconfont iconjichuxinxiguanli',
      title: '新零售商城',
      uri: '/newRetail/eulerApplets',
    },
    subMenus: [
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '首页内容管理',
          uri: '/newRetail/eulerApplets/homeContentManager',
        },
        component: () => import('./eulerApplets/homeContentManager/index.vue'),
        path: '/eulerApplets/homeContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '车系内容管理',
          uri: '/newRetail/eulerApplets/carContentManager',
        },
        component: () => import('./eulerApplets/carContentManager/index.vue'),
        path: '/eulerApplets/carContentManager'
      },
    ],
  },
  {
    meta: {
      icon: 'iconfont iconjichuxinxiguanli',
      title: 'WEY商城',
      uri: '/newRetail/weyApplets',
    },
    subMenus: [
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '首页内容管理',
          uri: '/newRetail/weyApplets/homeContentManager',
        },
        component: () => import('./weyApplets/homeContentManager/index.vue'),
        path: '/weyApplets/homeContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '车系内容管理',
          uri: '/newRetail/weyApplets/carContentManager',
        },
        component: () => import('./weyApplets/carContentManager/index.vue'),
        path: '/weyApplets/carContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '维修保养预约管理',
          uri: '/newRetail/weyApplets/maintainManager',
        },
        component: () => import('./weyApplets/maintainManager/index.vue'),
        path: '/weyApplets/maintainManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '置换补贴申请管理',
          uri: '/newRetail/weyApplets/replacementManager',
        },
        component: () => import('./weyApplets/replacementManager/index.vue'),
        path: '/weyApplets/replacementManager',
      },
    ],
  },
  {
    meta: {
      icon: 'iconfont iconjichuxinxiguanli',
      title: '欧拉商城',
      uri: '/newRetail/eulerH5',
    },
    subMenus: [
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '首页内容管理',
          uri: '/newRetail/eulerH5/homeContentManager',
        },
        component: () => import('./eulerH5/homeContentManager/index.vue'),
        path: '/eulerH5/homeContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '车系内容管理',
          uri: '/newRetail/eulerH5/carContentManager',
        },
        component: () => import('./eulerH5/carContentManager/index.vue'),
        path: '/eulerH5/carContentManager'
      },
    ],
  },
  {
    meta: {
      icon: 'iconfont iconjichuxinxiguanli',
      title: '皮卡商城',
      uri: '/newRetail/pickUp',
    },
    subMenus: [
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '首页内容管理',
          uri: '/newRetail/pickUp/homeContentManager',
        },
        component: () => import('./pickUp/homeContentManager/index.vue'),
        path: '/newRetail/pickUp/homeContentManager',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '车系内容管理',
          uri: '/newRetail/pickUp/carContentManager',
        },
        component: () => import('./pickUp/carContentManager/index.vue'),
        path: '/newRetail/pickUp/carContentManager'
      },
    ],
  },
];
